import { FunctionComponent, PropsWithChildren } from "react";

import dynamic from "next/dynamic";

import { InfoFormProps } from "./types";

export const DisplayWithInfoFormPreview = dynamic(
  () => import("./InfoFormSsr").then((mod) => mod.DisplayWithInfoFormPreviewSsr),
  {
    ssr: false,
  }
) as FunctionComponent<PropsWithChildren<InfoFormProps>>;

// Disabled SSR to avoid memory leak caused by styled
export const InfoForm = dynamic(() => import("./InfoFormSsr").then((mod) => mod.InfoFormSsr), {
  ssr: false,
}) as FunctionComponent<InfoFormProps>;
